<ng-container [ngSwitch]="variant">
  <button *ngSwitchCase="'link'"
          type="button"
          class="context-help-link btn btn-link p-0"
          [attr.aria-label]="'contextualHelp.openAria' | transloco: {topic: ariaTopic}"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-expanded]="panelOpen"
          (click)="openHelp()">
    {{ 'contextualHelp.learnMore' | transloco }}
  </button>

  <button *ngSwitchCase="'inline'"
          type="button"
          class="context-help-inline btn btn-link p-0"
          [attr.aria-label]="'contextualHelp.openAria' | transloco: {topic: ariaTopic}"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-expanded]="panelOpen"
          (click)="openHelp()">
    <i class="fas fa-question-circle" aria-hidden="true"></i>
    <span>{{ 'contextualHelp.help' | transloco }}</span>
  </button>

  <button *ngSwitchCase="'topbar'"
          type="button"
          class="context-help-topbar btn header-item noti-icon"
          [attr.aria-label]="'contextualHelp.openPageAria' | transloco"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-expanded]="panelOpen"
          (click)="openHelp()">
    <i class="bx bx-help-circle" aria-hidden="true"></i>
  </button>

  <button *ngSwitchDefault
          type="button"
          class="context-help-trigger btn btn-link p-0"
          [attr.aria-label]="'contextualHelp.openAria' | transloco: {topic: ariaTopic}"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-expanded]="panelOpen"
          (click)="openHelp()">
    <i class="fas fa-question-circle" aria-hidden="true"></i>
  </button>
</ng-container>

<section *ngIf="panelOpen"
         class="context-help-panel"
         role="dialog"
         [attr.aria-modal]="false"
         [attr.aria-label]="'contextualHelp.panelTitle' | transloco">
  <header class="context-help-panel__header">
    <div class="context-help-panel__heading">
      <span class="context-help-panel__title">
        {{ result?.article?.title || ('contextualHelp.panelTitle' | transloco) }}
      </span>
      <span *ngIf="result?.article?.helpArea" class="context-help-panel__subtitle">
        {{ result.article.helpArea }}
      </span>
    </div>
    <button type="button"
            class="context-help-panel__close btn btn-link p-0"
            [attr.aria-label]="'contextualHelp.close' | transloco"
            (click)="closeHelp()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </header>

  <div class="context-help-panel__body">
    <div *ngIf="result?.state === 'loading'" class="context-help-panel__status"
         role="status" aria-live="polite">
      {{ 'contextualHelp.loading' | transloco }}
    </div>

    <div *ngIf="result?.state === 'missing' || result?.state === 'unavailable' || result?.state === 'error'"
         class="context-help-panel__status context-help-panel__status--notice"
         role="status" aria-live="polite">
      {{ message() }}
    </div>

    <ng-container *ngIf="result?.state === 'found' && result?.article as article">
      <p *ngIf="article.isFallback" class="context-help-panel__fallback">
        {{ 'contextualHelp.englishOnlyFallback' | transloco }}
      </p>

      <p *ngIf="article.summary" class="context-help-panel__summary">{{ article.summary }}</p>

      <div *ngIf="renderedContent; else plainContent"
           class="context-help-panel__content"
           [innerHTML]="renderedContent"></div>
      <ng-template #plainContent>
        <p class="context-help-panel__content context-help-panel__content--plain">{{ article.content }}</p>
      </ng-template>

      <section *ngIf="article.relatedLinks?.length"
               class="context-help-panel__related"
               [attr.aria-label]="'contextualHelp.related' | transloco">
        <h3 class="context-help-panel__related-title">{{ 'contextualHelp.related' | transloco }}</h3>
        <ul class="context-help-panel__related-list">
          <li *ngFor="let link of article.relatedLinks">
            <button type="button"
                    class="context-help-panel__related-link btn btn-link p-0"
                    (click)="onRelatedLink(link)">
              <i class="fas"
                 [class.fa-external-link-alt]="link.type === 'external'"
                 [class.fa-book]="link.type !== 'external'"
                 aria-hidden="true"></i>
              <span>{{ link.title }}</span>
            </button>
          </li>
        </ul>
      </section>
    </ng-container>
  </div>
</section>
